const initialState = [];

export default (state = initialState, action) => {
    switch (action.type) {
        case "CLEAR_LICENCE_IMAGES":
            return initialState;
        case "LICENCE_IMAGES_RETRIEVED":
            return action.data;

        default:
            return state;
    }
}
